<template>
  <div>
    <fieldset>
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label class="form-label" for="quarterlystart"
              >Client quarterly start:</label
            >
            <b-select
              name="quarterlystart"
              class="form-select"
              v-model.number="form.quarterlystart"
            >
              <option selected value="1">January</option>
              <option value="2">February</option>
              <option value="3">March</option>
              <option value="4">April</option>
              <option value="5">May</option>
              <option value="6">June</option>
              <option value="7">July</option>
              <option value="8">August</option>
              <option value="9">September</option>
              <option value="10">October</option>
              <option value="11">November</option>
              <option value="12">December</option>
            </b-select>
          </div>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-md-4 d-flex align-items-center">
          <label class="form-check-label" for="showdashboard">Dashboard:</label>
         
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="showDashboard"
              v-model="form.showDashboard"
            />
         
        </div>

        <div class="col-md-4 d-flex align-items-center">
          <label class="form-check-label" for="showtraining"
            >Training module:</label
          >

            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="showtraining"
              v-model="form.showtraining"
            />
        
        </div>

        <div class="col-md-4 d-flex align-items-center">
          <label class="form-check-label" for="showNominations"
            >Nominations module:</label
          >
  
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="showNominations"
              v-model="form.showNominations"
            />
         
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="showsearch">Show search:</label>
          
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="showsearch"
              v-model="form.showsearch"
            />
         
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="showrproductpoints"
            >Show product points:</label
          >
      
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="showrproductpoints"
              v-model="form.showrproductpoints"
            />
         
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="showdescription"
            >Show program description:</label
          >
        
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="showdescription"
              v-model="form.showdescription"
            />
          
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="showbb"
            >Show bulletin board:</label
          >
          
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="showbb"
              v-model="form.showbb"
            />
        
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="mallLogo"
            >Use logo on mall page:</label
          >
      
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="mallLogo"
              v-model="form.mallLogo"
            />
        
        </div>

        <div class="col-md-4 mt-3  d-flex align-items-center">
          <label class="form-check-label" for="processorders"
            >Process orders:</label
          >
         
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="processorders"
              v-model="form.processorders"
            />
        
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="capturessnfedid"
            >Capture SSN/Federal ID:</label
          >
          
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="0"
              :true-value="1"
              role="switch"
              name="capturessnfedid"
              v-model="form.capturessnfedid"
            />
          
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="forceEmail">Force Email:</label>
          
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="forceEmail"
              v-model="form.forceEmail"
            />
         
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="require_pid_bathctool"
            >Require program ID in batch upload:</label
          >
          
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="require_pid_bathctool"
              v-model="form.require_pid_batchtool"
            />
          
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="hidePoints"
            >Remove points:</label
          >
          
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="hidePoints"
              v-model="form.hidePoints"
            />
          
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="security"
            >Require 90 day password change:</label
          >
          
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="security"
              v-model="form.security"
            />
          
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="showServicesAwards"
            >Service awards:</label
          >
         
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="showServiceAwards"
              v-model="form.showServicesAwards"
            />
          
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="serviceawardsingleorder"
            >Service awards single order:</label
          >
          
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="serviceawardsingleorder"
              v-model="form.serviceawardsingleorder"
            />
         
        </div>

        <div class="col-md-4 mt-3 d-flex align-items-center">
          <label class="form-check-label" for="showSocialRecognition"
            >Show social recognition:</label
          >
          
            <b-form-checkbox
              class="ml-2"
              switch
              :false-value="false"
              :true-value="true"
              role="switch"
              name="showSocialRecognition"
              v-model="form.showSocialRecognition"
            />
          
        </div>

        <div class="col-md-4 mt-3">
          <label class="form-label" for="socialRecognitionScope"
            >Social Recognition Scope:</label
          >
          <b-select
            name="socialRecognitionScope"
            multiple
            class="form-select"
          ></b-select>
        </div>

        <div class="col-md-12 text-center mt-3">
          <p><strong>(Remember to upload the logo)</strong></p>
        </div>

        <div class="row pl-2">
          <div class="col-md-12">
            <label class="form-label" for="bulletin">Bulletin:</label>
            <b-select class="form-select" v-model.number="form.bulletin">
              <option selected value="0">None</option>
              <option value="1">Wishlist</option>
              <option value="2">What's New</option>
              <option value="3">What's New</option>
            </b-select>
          </div>
        </div>

        <div class="row col-md-12">
          <div class="col-md-4 mt-3 d-flex align-items-center">
            <label class="form-check-label" for="allowTax"
              >Allow tax payment:</label
            >
            
              <b-form-checkbox
                class="ml-2"
                switch
                :false-value="false"
                :true-value="true"
                role="switch"
                name="allowtax"
                v-model="form.allowTax"
              />
           
          </div>

          <div class="col-md-4 mt-3 d-flex align-items-center">
            <label class="form-check-label" for="allowTaxPartial"
              >Allow partial tax payment:</label
            >
          
              <b-form-checkbox
                class="ml-2"
                switch
                :false-value="false"
                :true-value="true"
                role="switch"
                name="allowtaxPartial"
                v-model="form.allowTaxPartial"
              />
            
          </div>

          <div class="col-md-4 mt-3 d-flex align-items-center">
            <label class="form-check-label" for="grossUpTax"
              >Gross-up taxes:</label
            >
            
              <b-form-checkbox
                class="ml-2"
                switch
                :false-value="false"
                :true-value="true"
                role="switch"
                name="grossUpTax"
                v-model="form.grossUpTax"
              />
            
          </div>
        </div>

        <div class="row mt-3 col-md-12">
          <div class="col-md-5">
            <label for="taxPercentage" class="form-label"
              >Tax percentage:</label
            >
            <input
              type="number"
              class="form-control"
              name="taxPercentage"
              placeholder="0"
              v-model.number="form.taxPercentage"
            />
          </div>
        </div>

        <div class="row mt-3 col-md-12">
          <div class="col-md-12">
            <label for="minpointvalue" class="form-label"
              >Min point value:</label
            >
            <input
              type="text"
              class="form-control"
              name="minpointvalue"
              maxlength="5"
              v-model.number="form.minpointvalue"
            />
          </div>
        </div>

        <div class="row mt-3 col-md-12">
          <div class="col-md-12 ">
            <label for="maxpointvalue" class="form-label"
              >Max point value:</label
            >
            <input
              type="text"
              class="form-control"
              name="maxpointvalue"
              maxlength="5"
              @keypress="checkLimit"
              v-model.number="form.maxpointvalue"
            />
          </div>
        </div>

        <div class="row mt-3 col-md-12">
          <div class="col-md-12 d-flex align-items-center">
            <label class="form-check-label" for="maxpointvalue"
              >Force client secure password:</label
            >
          
              <b-form-checkbox
                class="ml-2"
                switch
                :false-value="false"
                :true-value="true"
                role="switch"
                name="showclientsecurepassword"
                v-model="form.showclientsecurepassword"
              />
          
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</template>
<script>
export default {
  name: "Miscellaneous",
  data() {
    return {};
  },
  computed: {
    form() {
      return this.$store.state.manageClients.form;
    },
  },
  methods: {
    checkLimit(){
      if (this.form.taxPercentage > 9999){
        this.form.taxPercentage = null;
        alert("Tax percentage cannot exceed 99999");
      }
      if (this.form.taxPercentage < 0){
        this.form.taxPercentage = null;
        alert("Tax percentage cannot be less than 0");
      }
    }
  }
};
</script>
<style></style>
